import Modal from '../modal/modal';
import { Dispatch, SetStateAction } from 'react';
import { FormTypeEnum } from '@employ-engage/data';
import { useTranslation } from 'react-i18next';

export interface FormTypePickerModalProps {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onFormTypeSelected: (formTypeSelected: FormTypeEnum) => void;
}

export function FormTypePickerModal({
  isOpen,
  onFormTypeSelected,
  setOpen,
}: FormTypePickerModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal open={isOpen} setOpen={setOpen}>
      <div className="bg-white p-4">
        <h2 className="text-xl font-bold">{t('Select Form Type')}</h2>
        <div className="flex justify-between mt-4 p-10 space-x-10">
          <div className="border-2 border-dashed rounded-lg p-10">
            <button
              onClick={() => onFormTypeSelected(FormTypeEnum.FROM_SCRATCH)}
              className="text-lg font-bold"
            >
              <i className="fa-solid fa-screwdriver-wrench text-4xl" />
              <p>{t('Build Form from Scratch')}</p>
            </button>
          </div>
          <div className="border-2 border-dashed rounded-lg p-10">
            <button
              onClick={() => onFormTypeSelected(FormTypeEnum.FROM_AI)}
              className="text-lg font-bold"
            >
              <i className="fa-solid fa-microchip-ai text-4xl" />
              <p>{t('Create with A.I.')}</p>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
